<template>
  <hm-content title="">
    <div class="table-panel flex flex-start mb20">
      <div>
        报表类型：
        <el-radio-group
          v-model="searchCondition.type"
          class="margin-right"
          size="small"
          disabled
        >
          <el-radio label="0">会员明细表</el-radio>
          <el-radio label="1">会员生理轴分布表</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="table-panel flex flex-wrap mb20">
      <div>
        会员类型：
      </div>
      <el-checkbox-group
        v-model="searchCondition.typeMember"
        size="small"
        class="ml10"
      >
        <el-checkbox label="pushMember">推会员</el-checkbox>
        <el-checkbox label="plusMember">Plus会员</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="table-panel flex flex-wrap mb20">
      <div class="flex item-center">
        会员注册时间段：
      </div>
      <el-date-picker
        v-model="searchCondition.createDate"
        type="datetimerange"
        align="right"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="会员注册开始时间"
        end-placeholder="会员注册结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
        clearable
      ></el-date-picker>
    </div>
    <div class="table-panel flex flex-between  mb20">
      <div>
        查询条件：
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始时间段筛选"
          end-placeholder="结束时间段筛选"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
          clearable
        ></el-date-picker>
      </div>
    </div>
    <div class="flex flex-between mb20">
      <el-button type="primary" size="small" @click="search"
        >生成报表</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div class="table">
      <el-table
        ref="table"
        :data="reportMemberList.records"
        style="width: 100%"
        stripe
        size="small"
        border
        @sort-change="sortChange"
        :default-sort="{ prop: 'num', order: 'descending' }"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="isShareMember"
          label="是否推会员"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.isShareMember === 'yes'">推会员</span>
              <span v-else>非推会员</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="isPlusMember"
          label="是否Plus会员"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.isPlusMember === 'yes'">Plus会员</span>
              <span v-else>非Plus会员</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobile"
          label="会员电话"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardNo"
          label="会员卡号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="openCardTime"
          label="注册日期"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="plusCardTime"
          label="成为Plus会员时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberTime"
          label="成为推会员时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="consumeTotalMoney"
          label="消费额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderNum"
          label="订单数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMoney"
          label="分销消费额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareOrderNum"
          label="分销订单数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnMoney"
          label="累计佣金"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="reportMemberList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      sort: {},
      searchCondition: {
        type: "0",
        typeMember: []
      },
      currentPage: 1,
      pageSize: 10,
      isOutputing: false
    };
  },
  computed: mapGetters(["reportMemberList"]),
  watch: {},
  created() {},
  mounted() {
    this.getParamsCookie();
    this.queryList();
  },
  methods: {
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        order: this.sort.order,
        prop: this.sort.prop
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.setParamsCookie();
      if (searchCondition.typeMember.length > 0) {
        searchCondition.typeMember.map(v => {
          if (v === "pushMember") {
            searchCondition.isShareMember = "yes";
          } else if (v === "plusMember") {
            searchCondition.isPlusMember = "yes";
          }
        });
      }
      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.openCardStartTime =
        this.searchCondition.createDate &&
        this.searchCondition.createDate.length > 0
          ? this.searchCondition.createDate[0]
          : "";
      searchCondition.openCardEndTime =
        this.searchCondition.createDate &&
        this.searchCondition.createDate.length > 0
          ? this.searchCondition.createDate[1]
          : "";

      Object.assign(params, searchCondition);

      return this.$store.dispatch("queryReportMemberList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "reportMemberListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "reportMemberListParams",
        type: "session"
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      let params = {
        pageSize: 999999,
        pageNo: 1,
        order: this.sort.order,
        prop: this.sort.prop
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      if (searchCondition.typeMember.length > 0) {
        searchCondition.typeMember.map(v => {
          if (v === "pushMember") {
            searchCondition.isShareMember = "yes";
          } else if (v === "plusMember") {
            searchCondition.isPlusMember = "yes";
          }
        });
      }
      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.openCardStartTime =
        this.searchCondition.createDate &&
        this.searchCondition.createDate.length > 0
          ? this.searchCondition.createDate[0]
          : "";
      searchCondition.openCardStartTime =
        this.searchCondition.createDate &&
        this.searchCondition.createDate.length > 0
          ? this.searchCondition.createDate[1]
          : "";

      Object.assign(params, searchCondition);

      return this.$store.dispatch("queryReportMemberList", params);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            res.result.records.forEach(v => {
              if (v.isShareMember === "yes") {
                v.isShareMember = "推会员";
              } else {
                v.isShareMember = "非推会员";
              }
              if (v.isPlusMember === "yes") {
                v.isPlusMember = "Plus会员";
              } else {
                v.isPlusMember = "非Plus会员";
              }
            });
            const list = res.result.records;
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            let title = "会员报表";

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
